export default "__VITE_ASSET__CYyugmn2__"